<h1>Try managing your Todos with VS Code Copilot</h1>

<ol>
  <li>VS Code installed
  <li>Being able to use Copilot in VS Code <b>(Free plan works as well)</b>
</ol>
<br>TL;DR: 
<ol>
  <li>Click here to <a href="{{ vs_code_link }}" data-test-vs-code-wizard-link>add to VS Code</a>
  <li>Click here to <a href="{{ vs_code_insiders_link }}">add to VS Code Insiders</a>.
</ol>




<br>You can read about using MCP servers in VS Code <a href="https://code.visualstudio.com/docs/copilot/chat/mcp-servers" target="_blank" rel="noopener">here</a>
<br>Unlike in Copilot Studio integration, the token is short-lived. You always get a working one in the config below and can refresh it any time.
<br>Everyone with the token will be able to manage your todos for a short period of time.

<br>
<br>To Add MCP server you can do one of the following:
<ol>
  <li>If you have configured the MCP server in Claude desktop version. You are done. VS Code will automatically autodiscover it. You can check your autodiscovery settings <a href="vscode://settings/chat.mcp.discovery.enabled">here</a>
  <li>Click this <a href="{{ vs_code_link }}" data-test-vs-code-wizard-link>link</a> to start the VS Code Wizard for adding/updating MCP servers. Installing twice updates the token.
  <li>Add the MCP server to your workspace. Add this to .vscode/mcp.json in a folder and start VS Code in the folder. Hover over todomcp and click start!
    <div class="json-container">
      <textarea id="config-json" disabled class="textarea" #configJson data-test-config-json title="config example">
{
  "servers": {
      "todomcp": {
          "type": "http",
          "url": "{{ url }}/mcp"
      }
  }
}
      </textarea>
      <button type="button" matRipple mat-icon-button="elevated" (click)="copyJson(configJson)" class="copy-button"  aria-label="Copy JSON to clipboard" data-test-copy-json-button>
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
</ol>

<br>
<video controls preload="none" poster="/vscode-poster.jpg">
  <source src="https://apps1storage.blob.core.windows.net/todo-videos/VSCode.mp4" type="video/mp4">
  Your browser does not support the video tag.
</video>